import styled from "styled-components";
import Button from "../../../../ui/button/Button";

export const StatusButton = styled(Button)`
  text-transform: capitalize;
`;
